import { localhostRoute } from './localhost-route'

export function apiRoute() {
  if (window.location.hostname === "localhost") {
    return localhostRoute().label;
  } else {
    return window.location.protocol + "//" + window.location.hostname;
  }
}
